export const environment = {
  production: true,
  apiUrl: `${document.location.protocol}//${document.location.host}/data-quest/api`,
  auth: {
    domain: 'dacoval-prod.eu.auth0.com',
    clientId: 'fLLL34CKqOUkSSeKfC3qSnYP3XQMHpzX',
    clientSecret:
      'RoJy6vtZmPoMvOBZaC9B06DXyVg933jHQ1Z89Sk1vB52zf0BOGmtL9HlNvgDqD6X',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://dataquest.azurewebsites.net',
      cookieDomain: '.azurewebsites.net',
      useCookiesForTransactions: true,
      SameSite: 'None',
    },
  },
};
